module.exports = __webpack_public_path__ + "static/prairie2-32784186c317c28832da07f181ffee94.jpg";